import './Main.css';

import Hero from './Hero/Hero.jsx';
import Offers from './Offers/Offers.jsx';
import Mission from './Mission/Mission.jsx';
import WhyCard from './WhyCard/WhyCard.jsx';
import Callback from './Callback/CallbackPage.jsx';
import Footer from '../../components/Footer/Footer.jsx';

export default function Main({ hasProducts }) {

  return (
 
      <main className="content">
        <Hero />
        <Offers hasProducts={hasProducts} />
        <Mission />
        <WhyCard />
        <Callback />
        <Footer />
      </main>


  )
}
